import { StructuredStorageBaseHelper } from './StructuredStorageBaseHelper';
export class ForEachValStructuredStorageHelper extends StructuredStorageBaseHelper {
    constructor({ each, ...rest }) {
        super(rest);
        this.each = each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.forEachStructuredStorageBase({
            type: this.type,
            each: (innerOptions) => {
                sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.if({
                    condition: () => {
                        sb.emitHelper(node, sb.pushValueOptions(innerOptions), sb.helpers.handleValValueStructuredStorage);
                    },
                    whenTrue: () => {
                        this.each(sb.noPushValueOptions(innerOptions));
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'DROP');
                    },
                }));
            },
        }));
    }
}

//# sourceMappingURL=ForEachValStructuredStorageHelper.js.map
